module.exports = __webpack_public_path__ + "img/capitools.8a1a9a1a.png";